/*
 * Regions- und Sprachwahl — Beiwerk zum Modal in snippets/rxk-localization-modal.liquid
 *
 * WICHTIG: Die eigentliche Umschaltung laeuft NICHT hier durch.
 * Jede Zeile ist ein <button type="submit" name="country_code" value="XX">;
 * das Formular geht auch ohne dieses Skript ab. Faellt JS aus, bleibt die Wahl
 * benutzbar — nur eben ohne Modal, Reiter, Suche und Sortierung.
 */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-rxk-loc]');
  if (!dialog) return;

  var locale = dialog.dataset.rxkLocLocale || 'en';
  var search = dialog.querySelector('[data-rxk-loc-search]');
  var empty = dialog.querySelector('[data-rxk-loc-empty]');
  var popular = dialog.querySelector('[data-rxk-loc-popular]');
  var lists = Array.prototype.slice.call(dialog.querySelectorAll('[data-rxk-loc-list]'));
  var tabs = Array.prototype.slice.call(dialog.querySelectorAll('[data-rxk-loc-tab]'));
  var panels = Array.prototype.slice.call(dialog.querySelectorAll('[data-rxk-loc-panel]'));

  /* ---------- Sortierung ---------- */

  /*
   * Shopify liefert available_countries nach Zeichencode sortiert. Im
   * Deutschen rutschen dadurch alle Umlaute vor das A:
   *
   *   Ägypten, Äquatorialguinea, Äthiopien, Afghanistan, Ålandinseln …
   *
   * Nach DIN gehoert Ägypten hinter Afghanistan. Intl.Collator kennt die
   * Regeln der jeweiligen Sprache — und zwar nicht nur fuer Deutsch: bei
   * Japanisch oder Arabisch waere eine Codepoint-Reihenfolge noch weniger
   * zu gebrauchen.
   *
   * Laeuft erst beim ersten Oeffnen, nicht beim Laden der Seite. Wer den
   * Waehler nie anfasst — die grosse Mehrheit — zahlt dafuer nichts.
   */
  var sorted = false;

  function sortLists() {
    if (sorted) return;
    sorted = true;

    if (typeof Intl === 'undefined' || !Intl.Collator) return;

    var collator;
    try {
      collator = new Intl.Collator(locale);
    } catch (e) {
      // Unbekanntes Locale-Tag: lieber Shopifys Reihenfolge als gar keine.
      return;
    }

    lists.forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      // Die Sprachliste traegt kein data-rxk-loc-name und bleibt in Ruhe:
      // ihre Reihenfolge gibt der Haendler in Shopify vor.
      if (!items.length || !items[0].dataset.rxkLocName) return;
      // Haeufige Laender aus den Theme-Einstellungen: Reihenfolge gewollt.
      if (list.hasAttribute('data-rxk-loc-fest')) return;

      items.sort(function (a, b) {
        return collator.compare(a.dataset.rxkLocName, b.dataset.rxkLocName);
      });

      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        frag.appendChild(item);
      });
      list.appendChild(frag);
    });
  }

  /* ---------- Reiter ---------- */

  function showPanel(name) {
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.setAttribute('aria-selected', String(tab.dataset.rxkLocTab === name));
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.dataset.rxkLocPanel !== name;
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      showPanel(tab.dataset.rxkLocTab);
    });
  });

  /* ---------- Oeffnen und Schliessen ---------- */

  /*
   * Die aktive Zeile in den sichtbaren Bereich holen. Bei rund 200 Laendern
   * steht die eigene Wahl sonst irgendwo weit unten und der Kunde sieht beim
   * Oeffnen nur "Afghanistan, Ägypten, Ålandinseln" — ohne Anhaltspunkt,
   * worauf der Shop gerade steht.
   */
  function revealCurrent() {
    var panel = dialog.querySelector('[data-rxk-loc-panel]:not([hidden])');
    if (!panel) return;

    var current = panel.querySelector('[aria-current="true"]');
    var scroller = panel.querySelector('[data-rxk-loc-scroll]');
    if (!current || !scroller) return;

    scroller.scrollTop = current.offsetTop - scroller.clientHeight / 2 + current.offsetHeight / 2;
  }

  function open(tab) {
    if (tab) showPanel(tab);
    sortLists();

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    revealCurrent();

    /*
     * Auf dem Telefon NICHT ins Suchfeld springen: die eingeblendete Tastatur
     * frisst dort die halbe Liste, noch bevor der Kunde ueberhaupt gesehen
     * hat, was zur Auswahl steht. Am Rechner ist der Sprung dagegen richtig —
     * dort tippt man los.
     */
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (search && !coarse) search.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rxk-loc-open]');
    if (trigger) {
      event.preventDefault();
      /*
       * Die Menue-Lade auf dem Handy bleibt sonst hinter dem Modal offen
       * stehen und ist nach dem Schliessen ploetzlich wieder da. Ist der
       * Ausloeser in keinem Dialog, passiert hier nichts weiter.
       */
      var drawer = trigger.closest('dialog[open]');
      if (drawer && drawer !== dialog && typeof drawer.close === 'function') drawer.close();

      open(trigger.dataset.rxkLocOpen);
      return;
    }

    if (event.target.closest('[data-rxk-loc-close]')) {
      dialog.close();
    }
  });

  /*
   * Klick auf den Hintergrund schliesst. <dialog> gibt dafuer kein eigenes
   * Ereignis — der Klick landet auf dem dialog selbst, weil die Karte darin
   * ihn sonst abfangen wuerde. Deshalb wird geprueft, ob der Zeiger ausserhalb
   * der Karte lag.
   */
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;

    var box = dialog.getBoundingClientRect();
    var outside =
      event.clientX < box.left ||
      event.clientX > box.right ||
      event.clientY < box.top ||
      event.clientY > box.bottom;

    if (outside) dialog.close();
  });

  /* ---------- Suche ---------- */

  if (search) {
    /*
     * Nur Format, kein Umbau: Gross-/Kleinschreibung egal, Akzente bleiben wie
     * sie sind. "Agypten" findet also "Ägypten" nicht — das waere eine
     * Normalisierung, die bei kyrillischen oder ostasiatischen Namen mehr
     * kaputt macht als sie hilft.
     */
    search.addEventListener('input', function () {
      var term = search.value.trim().toLowerCase();

      /*
       * Waehrend gesucht wird, faellt der Block der haeufigen Laender ganz
       * weg — sonst stuende ein Treffer zweimal da, einmal oben und einmal in
       * der Gesamtliste. Das passiert VOR der Schleife: die ueberspringt
       * ausgeblendete Listen, und beim Leeren des Feldes werden deren Zeilen
       * dadurch im selben Durchgang wieder eingeblendet.
       */
      if (popular) {
        popular.hidden = term !== '';
        var separator = popular.nextElementSibling;
        if (separator && separator.classList.contains('rxk-loc__sep')) {
          separator.hidden = term !== '';
        }
        // Ueberschriften "Haeufig gewaehlt" / "Alle Laender" gehoeren zum Block
        var titel = popular.previousElementSibling;
        if (titel && titel.classList.contains('rxk-loc__group')) titel.hidden = term !== '';
        var alle = dialog.querySelector('[data-rxk-loc-group-alle]');
        if (alle) alle.hidden = term !== '';
      }

      var hits = 0;
      lists.forEach(function (list) {
        if (list.hidden) return;
        Array.prototype.forEach.call(list.children, function (item) {
          if (!item.dataset.rxkLocName) return;

          /*
           * Gesucht wird ueber data-rxk-loc-terms: Name, ISO-Code und ein
           * paar Eigennamen ("usa", "holland"). Sortiert wird dagegen ueber
           * data-rxk-loc-name, den reinen Namen — sonst sortierte der
           * Collator die angehaengten Codes mit.
           */
          var haystack = item.dataset.rxkLocTerms || item.dataset.rxkLocName;
          var match = !term || haystack.indexOf(term) !== -1;
          item.hidden = !match;
          if (match) hits++;
        });
      });

      if (empty) empty.hidden = hits > 0;

      var scroller = dialog.querySelector('[data-rxk-loc-panel]:not([hidden]) [data-rxk-loc-scroll]');
      if (scroller) scroller.scrollTop = 0;
    });
  }

  /* Beim Schliessen aufraeumen, damit das naechste Oeffnen nicht mitten in
     einer alten Suche startet. */
  dialog.addEventListener('close', function () {
    if (!search) return;
    search.value = '';
    search.dispatchEvent(new Event('input'));
  });

  /* ---------- Tastatur ---------- */

  /*
   * Suchen ging schon, Blaettern nicht. Pfeiltasten wandern durch die
   * sichtbaren Zeilen des offenen Reiters — aus dem Suchfeld heraus springt
   * ArrowDown in die Liste. Enter loest den Knopf aus, das macht der Browser
   * von selbst, weil es echte submit-Knoepfe sind.
   */
  function visibleRows() {
    var panel = dialog.querySelector('[data-rxk-loc-panel]:not([hidden])');
    if (!panel) return [];

    return Array.prototype.filter.call(panel.querySelectorAll('.rxk-loc__row'), function (row) {
      var item = row.parentElement;
      var list = item.parentElement;
      return !item.hidden && !list.hidden;
    });
  }

  dialog.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Home' && key !== 'End') return;

    // Im Suchfeld gehoeren Pos1 und Ende dem Textcursor, nicht der Liste.
    if (document.activeElement === search && (key === 'Home' || key === 'End')) return;

    var rows = visibleRows();
    if (!rows.length) return;

    event.preventDefault();

    var index = rows.indexOf(document.activeElement);
    var next;

    if (key === 'Home') {
      next = rows[0];
    } else if (key === 'End') {
      next = rows[rows.length - 1];
    } else if (index === -1) {
      // Fokus liegt noch im Suchfeld oder auf einem Reiter.
      next = key === 'ArrowDown' ? rows[0] : rows[rows.length - 1];
    } else {
      var step = key === 'ArrowDown' ? 1 : -1;
      next = rows[(index + step + rows.length) % rows.length];
    }

    next.focus();
  });
})();
